import colors from './colors';
import text from './text';
import forms from './forms';
import cards from './cards';
import buttons from './buttons';
import {
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings
} from './fonts';
import shadows from './shadows';
import radii from './radii';

export default {
  colors,
  text,
  forms,
  cards,
  buttons,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  styles: {
    root: {
      fontFamily: 'heading',
      fontWeight: 'normal',
      fontSize: 'body',
      color: 'smoke.darker'
    }
  },
  shadows,
  radii
};
